import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';

import { getClassNames, isURL, formatDate } from '../../../utils/util';

import './message.scss';

const Message = ({ message, right, showSenderName }) => {
  const getDate = () => {
    if (!message.dateTime) {
      return formatDate(message.date + message.time, true, true);
    }

    return formatDate(message.dateTime, true, true);
  };

  const renderText = (text) => {
    const paragraphs = text.split('\n');
    return paragraphs.map((paragraph, index) => {
      if (paragraph === '') {
        return <br key={index} />;
      }

      const splitText = paragraph.split(' ');
      const textWithLinks = splitText.map((text, index) => {
        if (isURL(text)) {
          return (
            <Link key={index} className="message__link" target="_blank" to={text}>
              {text}
            </Link>
          );
        }

        if (index === splitText.length - 1) {
          return text;
        } else {
          return text + ' ';
        }
      });

      return <p key={index}>{textWithLinks}</p>;
    });
  };

  return (
    <li className={getClassNames('message', { right })}>
      <div className={getClassNames('message__bubble', { right })}>{renderText(message.message.trim())}</div>
      <div className="message__info">
        <p className="message__date-time">{getDate()}</p>
        {showSenderName && <p className="message__sender-name">{message.name}</p>}
      </div>
    </li>
  );
};

Message.propTypes = {
  message: PropTypes.shape({}),
  right: PropTypes.bool,
  showSenderName: PropTypes.bool,
};

Message.defaultProps = {
  message: undefined,
  right: false,
  showSenderName: false,
};

export default Message;
